import { useCallback } from "react";

import { supabase } from "../../../../services";

interface UseWebSocketAuthReturn {
  getAuthenticatedUrl: (baseUrl: string) => Promise<string>;
  isAuthenticated: () => Promise<boolean>;
}

export function useWebSocketAuth(): UseWebSocketAuthReturn {
  const getAuthenticatedUrl = useCallback(async (baseUrl: string): Promise<string> => {
    const {
      data: { session },
      error
    } = await supabase.auth.getSession();

    if (error) {
      throw new Error(`Authentication error: ${error.message}`);
    }

    if (!session?.access_token) {
      throw new Error("No access token available - user may need to re-authenticate");
    }

    return `${baseUrl}?bearer=${session.access_token}`;
  }, []);

  const isAuthenticated = useCallback(async (): Promise<boolean> => {
    try {
      const {
        data: { session },
        error
      } = await supabase.auth.getSession();

      if (error) {
        console.warn("Authentication check failed:", error.message);
        return false;
      }

      return !!session?.access_token;
    } catch (err) {
      console.error("Failed to check authentication status:", err);
      return false;
    }
  }, []);

  return {
    getAuthenticatedUrl,
    isAuthenticated
  };
}
